import type { Product } from '@/domains/productDiscovery/algolia/interfaces/product';
import type { WithSponsoredProduct } from '@/domains/productDiscovery/Listings/sponsoredProducts/interfaces/product';
import type { SponsoredProduct } from '@/domains/productDiscovery/Listings/sponsoredProducts/interfaces/sponsoredProduct';
import { getSponsoredProductsDisplayed } from '@/domains/productDiscovery/Listings/sponsoredProducts/utils/getSponsoredProductsDisplayed';
import { SponsoredProductsLocationType } from '@/productDiscovery/SponsoredProducts/interfaces/SponsoredProducts';
import { sendImpressionsTracking } from '@/productDiscovery/SponsoredProducts/utils/sendImpressionsTracking';

import type { productsImpressionTrackingPageType } from '../../interfaces';
import type { ViewedProduct } from '../../useProductsImpressionTracking';

export const handleSponsoredProductsImpressionsTracking = (
  viewedProducts: ViewedProduct[],
  pageType: productsImpressionTrackingPageType,
  currentPage: number,
  sponsoredProductsConfig?: SponsoredProduct[],
) => {
  let listingPage = '';
  if (pageType === 'search_listing') {
    listingPage = SponsoredProductsLocationType.SEARCH_PAGE;
  } else if (pageType === 'category_listing') {
    listingPage = SponsoredProductsLocationType.CATEGORY_PAGE;
  } else if (pageType === 'google_shopping') {
    listingPage = SponsoredProductsLocationType.GOOGLE_SHOPPING_PAGE;
  } else if (pageType === 'masslanding_listing') {
    listingPage = SponsoredProductsLocationType.MASS_LANDING_PAGE;
  }

  const viewedSponsoredProducts: (Product & WithSponsoredProduct)[] =
    viewedProducts
      .map((viewedProduct) => viewedProduct.product)
      .filter(
        (viewedProduct) =>
          'isSponsored' in viewedProduct &&
          'position' in viewedProduct &&
          viewedProduct.isSponsored &&
          viewedProduct.position !== null,
      ) as (Product & WithSponsoredProduct)[];

  if (viewedSponsoredProducts.length && sponsoredProductsConfig) {
    const sponsoredDisplayed = getSponsoredProductsDisplayed(
      viewedSponsoredProducts,
      sponsoredProductsConfig,
    );

    // Send call to ms.sp-tracking
    if (listingPage) {
      sendImpressionsTracking(
        sponsoredDisplayed,
        listingPage as SponsoredProductsLocationType,
        currentPage,
      );
    }
  }
};
